import { activeProjectVar, isLoadingVar, tokenVar } from 'modulesCommon/store'

import { queryParamsToString } from 'shared/utils/queryParamsToString'

export const uploadFile = async (blob: File | string, params: any) => {
  isLoadingVar(true)

  try {
    const res = await fetch(`${process.env.REACT_APP_UPLOAD_URL as string}?${queryParamsToString(params)}`, {
      method: 'POST',
      headers: {
        authorization: tokenVar()
      },
      body: blob
    })

    const resData = await res.json()

    return resData
  } catch (error) {
    console.log(error)
  } finally {
    isLoadingVar(false)
  }
}

export const uploadPhoto = (blob: File, resize: boolean = true) => {
  const params: Record<string, any> = {
    id: activeProjectVar().id,
    image_name: blob.name,
    image_type: blob.type,
    resize
  }

  return uploadFile(blob, params)
}

export const uploadBase64 = (blob: string, resize: boolean = true) => {
  const params: Record<string, any> = {
    id: activeProjectVar().id,
    image_name: Date.now().toString(),
    image_type: 'image/png',
    resize
  }

  return uploadFile(blob, params)
}
